import { mapGetters } from 'vuex';
import accountVerifyMixin from '@/mixins/accountVerify';
import socialLevelMixin from '@/mixins/socialLevel';
import unreadNotificationMixin from '@/mixins/unreadNotification';

export default {
  mixins: [accountVerifyMixin, socialLevelMixin, unreadNotificationMixin],
  props: {
    showIcons: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'leaderboardsEnabled']),
    ...mapGetters('user', ['isLoggedIn']),
    enabledLinks() {
      return this.links.filter((i) => i.enabled);
    },
    links() {
      if (this.isLoggedIn) {
        return [
          {
            title: 'Markets',
            name: 'markets',
            href: { name: 'market-list' },
            enabled: true,
          },
          {
            title: 'News',
            name: 'news',
            href: '/news',
            enabled: true,
          },
          {
            title: 'Leaderboards',
            name: 'leaderboards',
            href: '/leaderboards',
            enabled: this.leaderboardsEnabled,
          },
          {
            title: 'Account',
            name: 'account',
            href: this.accountLink,
            enabled: true,
          },
          {
            title: 'Dashboard',
            name: 'dashboard',
            href: '/dashboard',
            enabled: true,
          },
        ];
      }

      return [
        {
          title: 'Markets',
          name: 'markets',
          href: { name: 'market-list' },
          enabled: true,
        },
        {
          title: 'News',
          name: 'news',
          href: '/news',
          enabled: true,
        },
        {
          title: 'Learn',
          name: 'learn',
          href: '/learn',
          enabled: true,
        },
        {
          title: 'Leaderboards',
          name: 'leaderboards',
          href: '/leaderboards',
          enabled: this.leaderboardsEnabled,
        },
      ];
    },
  },
  methods: {
    classModifier(name) {
      const routes = ['market-details'];
      const dontHighlight = routes.includes(this.$route.name);
      return {
        [`main-nav__link-with-icon main-nav__link-with-icon--${name}`]: this.showIcons,
        'main-nav__link--no-highlight': dontHighlight,
        'main-nav__link': true,
      };
    },
    showSocialAvatarOnMobile(item) {
      return this.isLayoutMobile && item.name === 'dashboard' && this.isLoggedIn;
    },
    onAvatarClick() {
      this.$router.push({ name: 'portfolio' });
    },
    onLinkClick(href) {
      // scroll page to top if link is clicked again
      if (this.$route && this.$route.path === href) {
        window.scrollTo(0, 0);
      }
    },
  },
};
